<template>
  <div
    class="badge badge-circle badge-circle-sm no-text approval-badge"
    :class="{
      'badge-success-hollow': approval === 'A',
      'badge-danger-hollow': approval === 'R',
      A: approval === 'A',
    }">
    <media-owner-approval-status-icon
      :status="approval"
      :use-monochrome-icons="true" />
  </div>
  <span>{{ capitalize(labelFormatted) }}</span>
</template>

<script setup lang="ts">
  import { capitalize, computed } from 'vue';

  import { getValueOrDash } from '@/globals';
  import MediaOwnerApprovalStatusIcon from '@/org-app/components/dashboards/MediaOwnerApprovalStatusIcon.vue';
  import i18n from '@/vueI18n';

  const { approval } = defineProps<{
    approval: 'P' | 'A' | 'R';
  }>();

  const label = computed(() => {
    switch (approval) {
      case 'A':
        return i18n.global.t('states.approved');
      case 'R':
        return i18n.global.t('states.rejected');
      case 'P':
        return i18n.global.t('states.pendingApproval');
      default:
        return null;
    }
  });

  const labelFormatted = computed(() => capitalize(getValueOrDash(label.value)));
</script>
